import HEAD from '@/components/Head.vue'
import Search from '@/components/Search.vue'
import Footer from '@/components/Footer.vue'
import Nav from '@/components/Nav.vue'
import Floor from '@/components/Floor.vue'
import Guarantee from '@/components/Guarantee.vue'
import Breadcarst from '@/components/Breadcarst.vue'
import Sixpsd from '@/components/sixPsd.vue'
import SettingNav from '@/components/SettingNav.vue'
import Steps from '@/components/steps.vue'
import LoginBottom from '@/components/LoginBottom.vue'
import Logistics from '@/components/Logistics.vue'
import ProgressTrack from '@/components/ProgressTrack.vue'
import magnifier from '@/components/magnifier.vue'
import searchItem from '@/components/searchItem.vue'
export default {
    install: function (Vue) {
    Vue.component('public-head', HEAD)
    Vue.component('public-search', Search)
    Vue.component('public-footer', Footer)
    Vue.component('public-nav', Nav)
    Vue.component('public-floor', Floor)
    Vue.component('public-guarantee', Guarantee)
    Vue.component('breadCarst', Breadcarst)
    Vue.component('sixPsd', Sixpsd)
    Vue.component('setNav', SettingNav)
    Vue.component('steps', Steps)
    Vue.component('loginBottom', LoginBottom)
    Vue.component('Logistics', Logistics)
    Vue.component('ProgressTrack', ProgressTrack)
    Vue.component('magnifier', magnifier)  
    Vue.component('search-item', searchItem);
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js